/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.EndlessScrollList = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			mod.url = mod.$ctx.data('url') || '';
			mod.page = mod.$ctx.data('start') || 0;
			mod.container = mod.$ctx.find('.scroll-list-container');
			mod.loadingIndicator = mod.$ctx.find('.modLoadingIndicator');
			mod.loadingIndicator.on('visible', $.proxy(mod.loadContent, mod));
			callback();
		},

		getUrl: function () {
			var mod = this,
				url = mod.url;
			url = url.replace('${page}', mod.page);
			return url;
		},

		loadContent: function () {
			var mod = this, newContent;
			if (!mod.finished && !mod.loading) {
				mod.loading = true;
				$.ajax({
					url: mod.getUrl(),
					success: function (response) {
						mod.page++;
						mod.loading = false;
						response = (response || '').trim();
						if (response) {
							newContent = $('<div>').addClass('scroll-list-page').html(response);
							mod.container.append(newContent);
							SCS.utils.initNewModules(newContent);
						} else {
							mod.finished = true;
							mod.loadingIndicator.addClass('hidden');
							mod.loadingIndicator.trigger('stop');
						}
					},
					error: function () {
						mod.loading = false;
					}
				});
			}
		}
	});

}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.EndlessScrollList.js
// module id = 140
// module chunks = 0